// extracted by mini-css-extract-plugin
export default {"text-info":"TextInfo_text-info__9lA0o","text-info--user":"TextInfo_text-info--user__7DPny","text-info--log":"TextInfo_text-info--log__WZ9p+"};